import LeafletMap from './leaflet'

class FullScreenMap extends LeafletMap {
  constructor(el) {
    super()
    this.el = el
    this.initialize()
    this.resize = this.resize.bind(this)

    $(window).on('resize', this.resize)
    this.resize()
  }

  // custom resize method to resize the map to the viewport
  async resize() {
    return new Promise(resolve => {
      const navbarSize = 60
      const height = $(window).height() - navbarSize
      this.el.css('height', height)
      if (this.map) {
        this.map.invalidateSize()
      }
      resolve()
    })
  }
}

export default FullScreenMap
